import React from "react";
import './Categories.css'; // Import the CSS file for styling the Categories component

import { Heading } from "../../../components"; // Import necessary components from the components directory 
import { cars } from "../../../constants"; // Import the cars data from the constants directory

import { Link } from "react-router-dom"; // Import Link from react-router-dom for navigation



const Categories = () => {

  /**
   * Function to get the most popular car categories based on the cars data.
   * @param {Array} cars - The array of car objects.
   * @returns {Array} - An array of the top 6 categories with their count, image, and index.
   */
  const getPopularCarCategories = (cars) => {

    const categoryCount = {}; // Object to store the count of each car type
    const categoryImage = {}; // Object to store an image for each car type

    // Count occurrences of each carType and store an image
    cars.forEach((car) => {
        const category = car.details.carType; // Get the car type (category)
        categoryCount[category] = (categoryCount[category] || 0) + 1; // Increment count for the category
        if (!categoryImage[category]) categoryImage[category] = car.image; // Store first car's image
    });

    // Convert to an array, sort by count (descending), and take the top 6
    return Object.entries(categoryCount)
      .sort((a, b) => b[1] - a[1])
      .slice(0, 6) // Limit to top 6 categories
      .map(([category, count], index) => ({
          index: index + 1, // Add index (1-based)
          category,
          count,
          image: categoryImage[category],
      }));
  };

  // Get the top 6 popular car categories
  const categories = getPopularCarCategories(cars);

  return (
    <section className="categories">

      {/* Section Heading */}
      <Heading title={'Popular Category'} subTitle={'Explore Categories'} />

      {/* Category Items */}
      <div className="box-container">
        {/* Map over the categories array to render each category */}
        {categories.map(({ index, category, count, image }) => (
          <div key={category} className={`category-item category-${index}`}>

            <img src={image} alt={category} /> {/* Category Image */}

            <div className="content">
              <div className="label">{count} Listing</div> {/* Number of Listings */}
              <Link to={`/Cars?carType=${encodeURIComponent(category)}`}> {/* Link to Filtered Cars Page */}
              <h3>{category}</h3> {/* Category Name */}
              </Link>
            </div>

          </div>
        ))}
      </div>

    </section>
  );
};

export default Categories;